export default __webpack_public_path__ + "static/media/2728 knife block A top.842c5f3d.png";